import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  return _openBlock(), _createBlock(_component_el_radio_group, {
    modelValue: _ctx.innerValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.innerValue = $event),
    disabled: _ctx.disabled,
    onChange: _ctx.handleChange,
    class: "w-radio-group",
    "data-test": _ctx.dataTest
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parsedOptions, option => {
      return _openBlock(), _createBlock(_component_el_radio, {
        key: option.value,
        value: option.value,
        disabled: option.disabled === true,
        "data-test": _ctx.dataTest ? `${_ctx.dataTest}-${option.value}` : undefined
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.labelToDisplay(option.label)), 1)]),
        _: 2
      }, 1032, ["value", "disabled", "data-test"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "disabled", "onChange", "data-test"]);
}